import type { DeliveryOption } from "@jti/commerce";
import { DeliveryOptionType } from "@jti/store/slices/LEGACY__checkoutSlice";

export const getDeliveryOptionType = (deliveryOption: DeliveryOption): DeliveryOptionType => {
  const optionTypeMatchingMap = {
    [DeliveryOptionType.CustomDeliveryOption]: deliveryOption?.widgetTagName && deliveryOption.widgetUrl,
    [DeliveryOptionType.InStoreJti]: deliveryOption?.flotiqApiKey,
  };

  const deliveryOptionType = Object.keys(optionTypeMatchingMap).find(
    (key) => optionTypeMatchingMap[key as keyof typeof optionTypeMatchingMap]
  );

  return (deliveryOptionType as DeliveryOptionType) ?? DeliveryOptionType.AtHome;
};

export const getCurrentDeliveryOptionType = (
  deliveryOptions: DeliveryOption[],
  methodCode: string
): DeliveryOptionType => {
  const selectedDeliveryOption = deliveryOptions.find((option) => option.methodCode === methodCode);

  if (!selectedDeliveryOption) {
    return DeliveryOptionType.AtHome;
  }

  return getDeliveryOptionType(selectedDeliveryOption);
};
